import { Box } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useState } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";

import StyledBanner from "components/Styled/Banner";
import ReferralDialogNavigation from "features/Home/ReferralDialog/navigation";
import { REFERRAL_CREDIT } from "utils/influencer";
import { DISMISSED_ANNUAL_PLAN_BANNER } from "utils/localStorage";
import { trackEvent } from "utils/tracking";

const SpecialAnnouncementCard = () => {
  const { subscription, setUpgradeDialogSource } =
    useContext(SubscriptionContext);
  const { currentOrg } = useContext(OrganizationUserContext);
  const [navigationReferDialog, setNavigationReferDialog] = useState(false);

  const annualBannerKey = `${DISMISSED_ANNUAL_PLAN_BANNER}-${currentOrg?.id}`;
  const [dismissedAnnualBanner, setDismissedAnnualBanner] = useState(
    localStorage.getItem(annualBannerKey) === "true",
  );

  const isAnnualPlan = subscription?.subscription?.planName?.includes("yearly");

  if (!isAnnualPlan) {
    if (dismissedAnnualBanner) {
      return null;
    }
    return (
      <StyledBanner
        icon={<Box component="i" className="fa-regular fa-star" />}
        snippet="Lock in current pricing for a full year"
        description="· Save over 25% before rates increase."
        buttonText="Subscribe annual"
        handleClick={() => {
          setUpgradeDialogSource(UpgradeDialogSource.annual_plan_home_page);
        }}
        onClose={() => {
          localStorage.setItem(annualBannerKey, "true");
          setDismissedAnnualBanner(true);
        }}
      />
    );
  } else {
    return (
      <>
        <StyledBanner
          snippet="🥳 Invite Friends, Get Rewarded"
          title=""
          description={
            <>
              {" "}
              Give ${REFERRAL_CREDIT} to a new user. Get ${REFERRAL_CREDIT} when
              they subscribe. Credits will be auto-applied towards your next
              invoice.
            </>
          }
          buttonText="Start Referring"
          handleClick={() => {
            trackEvent("Referral Promo Button Clicked");
            setNavigationReferDialog(true);
          }}
        />
        <ReferralDialogNavigation
          open={navigationReferDialog}
          close={() => setNavigationReferDialog(false)}
          source="Referral Promo Button Clicked"
        />
      </>
    );
  }
};

export default SpecialAnnouncementCard;
